module.exports = __webpack_public_path__ + "static/media/DSC_1330-Pano.56c9c71b.jpg";